import React, { useState } from "react";
import {
  View,
  StyleSheet,
  Text,
  ScrollView,
  Dimensions,
  ImageBackground,
  Image,
  TouchableOpacity,
  useWindowDimensions,
} from "react-native";
import AppImages from "../../Constants/AppImages";
import AppColors from "../../Constants/AppColors";
import AppFonts from "../../Constants/AppFonts";
import Appstyles from "../../Constants/AppStyles";
import {
  MasterDataone,
  MasterDatatwo,
  MasterSettingsData,
  MasterSettingsDataone,
  Usersone,
  Userstwo,
} from "../../Constants/Data";
import { useNavigate } from "react-router-dom";

const Users = ({ navigation }) => {
  const { width: screenWidth, height: screenHeight } = useWindowDimensions();
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedIndexone, setSelectedIndexOne] = useState(null);

  const isTablet = screenWidth >= 768;
  const isDesktop = screenWidth >= 1024;

  const handleItemSelection = (index) => {
    setSelectedIndex(index);
    setSelectedIndexOne(null);
  };

  const handleItemSelectionone = (index) => {
    setSelectedIndexOne(index);
    setSelectedIndex(null);
  };

  // Responsive styles
  const responsiveStyles = {
    cardContainer: {
      flexDirection: isDesktop ? "row" : "column",
      marginTop: isDesktop ? screenHeight * 0.15 : screenHeight * 0.12,
      borderRadius: 12,
      paddingHorizontal: isDesktop ? 20 : 15,
      justifyContent: "space-between",
    },
    column: {
      width: isDesktop ? "48%" : "100%",
      alignItems: isDesktop ? "flex-start" : "center",
      marginTop: isDesktop ? -screenHeight * 0.08 : 0,
    },
    columnRight: {
      width: isDesktop ? "48%" : "100%",
      alignItems: isDesktop ? "flex-end" : "center",
      marginTop: isDesktop ? 20 : 0,
    },
    cardTouchable: {
      alignItems: isDesktop ? "flex-start" : "center",
      marginBottom: isTablet ? 40 : 30,
      height: isDesktop ? screenHeight * 0.2 : screenHeight * 0.16,
      width: isDesktop ? "auto" : "100%",
      borderRadius: 10,
    },
    cardTouchableRight: {
      alignItems: isDesktop ? "flex-end" : "center",
      justifyContent: "flex-end",
      borderRadius: 10,
      marginTop: isDesktop ? 30 : 20,
      marginBottom: isDesktop ? 0 : 20,
      height: isDesktop ? screenHeight * 0.2 : screenHeight * 0.16,
      width: isDesktop ? "auto" : "100%",
    },
    headerImageBg: {
      height: screenHeight, // Full height of window
      width: "100%",
      position: "absolute",
      top: 0,
      left: 0,
    },
    scrollView: {
      flex: 1,
      zIndex: 1,
      marginTop: screenHeight * 0.1, // Adjust based on your header height
      backgroundColor: "transparent",
      marginHorizontal: isDesktop ? 20 : 15,
    },
    cardContent: {
      width: isDesktop ? "85%" : isTablet ? "90%" : "95%",
      alignItems: "center",
    },
    contentContainer: {
      backgroundColor: "white",
      borderRadius: 12,
      flex: 1,
      paddingVertical: 20,
      minHeight: screenHeight * 0.6, // Ensure minimum height
    },
  };

  // Combine all data for better rendering on smaller screens
  const allUsersData = [...Usersone, ...Userstwo];
  const navigate = useNavigate();
  const renderItem = ({ item, index, isLeftColumn }) => {
    const isSelected = isLeftColumn
      ? index === selectedIndex
      : index === selectedIndexone;
    const handlePress = isLeftColumn
      ? handleItemSelection
      : handleItemSelectionone;

    return (
      <TouchableOpacity
        onPress={() => {
          handlePress(index);
          navigate(`/${item.nav}`);
        }}
        style={
          isLeftColumn
            ? responsiveStyles.cardTouchable
            : responsiveStyles.cardTouchableRight
        }
        underlayColor="transparent"
        key={`${isLeftColumn ? "left" : "right"}-${index}`}
      >
        <View style={{ backgroundColor: "white", borderRadius: 10 }}>
          {isSelected ? (
            <View style={Appstyles.seleCard}>
              <View style={responsiveStyles.cardContent}>
                <Image
                  source={item.img}
                  style={Appstyles.cardImg}
                  resizeMode="contain"
                />
                <Text style={[Appstyles.seleText]}>{item.title}</Text>
              </View>
            </View>
          ) : (
            <View style={Appstyles.notselView}>
              <View style={responsiveStyles.cardContent}>
                <Image
                  source={item.img}
                  style={Appstyles.cardImg}
                  resizeMode="contain"
                />
                <Text style={[Appstyles.NoseleText]}>{item.title}</Text>
              </View>
            </View>
          )}
        </View>
      </TouchableOpacity>
    );
  };

  // For mobile/tablet - single column layout
  const renderSingleColumn = () => (
    <View style={{ width: "100%", alignItems: "center" }}>
      {allUsersData.map((item, index) => (
        <TouchableOpacity
          key={`mobile-${index}`}
          onPress={() => {
            // handlePress(index);
            navigate(`/${item.nav}`);
          }}
          style={{
            alignItems: "center",
            marginBottom: 20,
            height: screenHeight * 0.14,
            width: "100%",
            borderRadius: 10,
          }}
          underlayColor="transparent"
        >
          <View
            style={{
              backgroundColor: "white",
              borderRadius: 10,
              width: "100%",
            }}
          >
            {index === selectedIndex ? (
              <View style={[Appstyles.seleCard, { width: "100%" }]}>
                <View style={responsiveStyles.cardContent}>
                  <Image
                    source={item.img}
                    style={Appstyles.cardImg}
                    resizeMode="contain"
                  />
                  <Text style={Appstyles.seleText}>{item.title}</Text>
                </View>
              </View>
            ) : (
              <View style={[Appstyles.notselView, { width: "100%" }]}>
                <View style={responsiveStyles.cardContent}>
                  <Image
                    source={item.img}
                    style={Appstyles.cardImg}
                    resizeMode="contain"
                  />
                  <Text style={Appstyles.NoseleText}>{item.title}</Text>
                </View>
              </View>
            )}
          </View>
        </TouchableOpacity>
      ))}
    </View>
  );

  return (
    <View style={{ backgroundColor: AppColors.sandal, flex: 1 }}>
      {/* Full Screen Background Image */}
      <ImageBackground
        source={AppImages.blurMap}
        style={responsiveStyles.headerImageBg}
        imageStyle={{
          borderBottomLeftRadius: 20,
          borderBottomRightRadius: 20,
        }}
      >
        {/* Header Content */}
        <View style={Appstyles.headerview}>
          <View style={Appstyles.fullAlignment}>
            <TouchableOpacity
              style={Appstyles.goback}
              onPress={() => {
                if (
                  typeof window !== "undefined" &&
                  window.history.length > 1
                ) {
                  window.history.back();
                } else {
                  window.location.href = "/";
                }
              }}
            >
              <Image
                source={AppImages.Backbtn}
                style={{ width: 8, height: 15 }}
              />
            </TouchableOpacity>
            <Text
              style={{
                color: AppColors.brown,
                fontFamily: AppFonts.OverpassMedium,
                fontSize: isDesktop ? 18 : 16,
              }}
            >
              Users
            </Text>
          </View>

          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
              <Image
                source={AppImages.Bellnoti}
                style={{
                  width: isDesktop ? 18 : 16,
                  height: isDesktop ? 22 : 20,
                }}
                resizeMode="contain"
              />
            </TouchableOpacity>
          </View>
        </View>
      </ImageBackground>

      {/* Content ScrollView */}
      <ScrollView
        style={responsiveStyles.scrollView}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ flexGrow: 1 }}
      >
        <View
          style={[
            responsiveStyles.contentContainer,
            responsiveStyles.cardContainer,
          ]}
        >
          {isDesktop ? (
            // Desktop - two column layout
            <>
              <View style={responsiveStyles.column}>
                {Usersone.map((item, index) =>
                  renderItem({ item, index, isLeftColumn: true })
                )}
              </View>
              <View style={responsiveStyles.columnRight}>
                {Userstwo.map((item, index) =>
                  renderItem({ item, index, isLeftColumn: false })
                )}
              </View>
            </>
          ) : (
            // Mobile/Tablet - single column layout
            renderSingleColumn()
          )}
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  // Keep your existing styles here for fallback
  scrollView: {
    zIndex: 1,
    marginTop: 0,
    backgroundColor: "transparent",
  },
});

export default Users;
